import {EntityType, FinancialEntityType} from "../../../__generated__/generated_types";
import {FinancialEntity} from "../../../contexts/chartofaccounts/ChartOfAccountsContext";

export const NAME_PREVIEW_LIMIT = 3;
export const DEFAULT_GROUP_KEY = "default";

export function isDefaultGroup(id: string | null | undefined): boolean {
    return id == null;
}

export function groupKey(id: string | null | undefined): string {
    return id ?? DEFAULT_GROUP_KEY;
}

export function previewNames(names: string[]): string {
    if(names.length === 0) {
        return "";
    }
    if(names.length <= NAME_PREVIEW_LIMIT) {
        return names.join(", ");
    }
    return `${names.slice(0, NAME_PREVIEW_LIMIT).join(", ")}...`;
}

export function financialEntityDisplayName(entity: FinancialEntity | undefined, fallbackId: string): string {
    if(!entity) {
        return fallbackId;
    }
    if(entity.number) {
        return `${entity.number} ${entity.name}`;
    }
    return entity.name;
}

export function financialEntityTypeToEntityType(type: FinancialEntityType): EntityType {
    switch(type) {
        case FinancialEntityType.Account:
            return EntityType.Account;
        case FinancialEntityType.Category:
            return EntityType.BudgetCategory;
        case FinancialEntityType.Component:
            return EntityType.BudgetComponent;
        default:
            return EntityType.Account;
    }
}

export function entityTypeLabel(type: EntityType | FinancialEntityType): string {
    if(type === EntityType.Account || type === FinancialEntityType.Account) {
        return "Account";
    }
    if(type === EntityType.BudgetCategory || type === FinancialEntityType.Category) {
        return "Category";
    }
    if(type === EntityType.BudgetComponent || type === FinancialEntityType.Component) {
        return "Component";
    }
    return "Entity";
}
